import useSWR from "swr";
import { type CompanyGroup } from "../types";
import { simpleFetcher } from "../fetcher";

export function useCompanyGroups() {
  return useSWR<CompanyGroup[], Error>(
    "/api/v2/company-groups",
    simpleFetcher,
    { revalidateOnFocus: false },
  );
}
